import { inject } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivateFn, UrlTree } from '@angular/router';
import { CreatReviewComponent } from '@app/pages/reviews/pages/creat-review/creat-review.component';
import { ConfirmAlertComponent, EConfirmButton, AlertConfigModel } from '@shared/components/confirm-alert/confirm-alert.component';
import { DRAFT_KEY, DraftModel, IReviewDraftTemp } from '@shared/helper/draft/models/draft.model';
import { LocalRepository } from '@shared/helper/local-repository';
import { Observable, map, of } from 'rxjs';


export const reviewGuard: CanDeactivateFn<CreatReviewComponent> = (component: CreatReviewComponent):
  Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  const dialog: MatDialog = inject(MatDialog);
  const bottomSheet: MatBottomSheet = inject(MatBottomSheet);
  const localRepository: LocalRepository = inject(LocalRepository);

  const dialogInfo: AlertConfigModel = {
    cancelButtonText: 'بله می‌روم',
    confirmButtonText: 'خیر ادامه می‌دهم',
    title: 'می‌خواهید به صفحۀ دیگری بروید؟',
  };

  if (!!(component?.userReview?.body) || !!(component?.userReview?.mediaId) || !!(component?.book?.myRate?.averageRate || component?.userReview?.rate || component?.aggReview?.review?.data?.rate)) {
    if (localRepository.IsInMobile) {
      const bottomSheetRef = bottomSheet.open(ConfirmAlertComponent, {
        data: dialogInfo,
        panelClass: 'basic-bottomsheet'
      });

      return bottomSheetRef.afterDismissed().pipe(
        map((action: EConfirmButton) => handleAction(action, component, localRepository))
      );
    } else {
      const dialogRef = dialog.open(ConfirmAlertComponent, {
        data: dialogInfo,
        panelClass: 'basic-dialog'
      });

      return dialogRef.afterClosed().pipe(
        map((action: EConfirmButton) => handleAction(action, component, localRepository))
      );
    }
  }
  return of(true);
};

function handleAction(action: EConfirmButton, component: any, localRepository: LocalRepository): boolean {
  if (action === EConfirmButton.CANCLE) {
    let existData: DraftModel = JSON.parse(localRepository.getLocalItem(DRAFT_KEY)!) || new DraftModel();
    const existDraftReview = existData?.review?.data?.findIndex(draft => draft.bookId == component.bookId);
    const draftReview: IReviewDraftTemp = {
      body: component.userReview.body,
      bookId: component.bookId,
      rate: component?.book?.myRate?.averageRate || component?.userReview?.rate || +component?.aggReview?.review?.data?.rate,
      spoilerAlert: component.spoiler
    };

    if (existDraftReview! >= 0) {
      existData.review!.data[existDraftReview!] = draftReview;
    } else {
      existData?.review?.data?.push(draftReview);
    }
    const data: DraftModel = {
      review: {
        draftKey: 'review',
        data: existData?.review?.data!
      }
    };
    if (!existData) {
      existData = new DraftModel();
    }
    existData.review = data.review;
    localRepository.setLocalItem(DRAFT_KEY, JSON.stringify(existData));
    return true;
  } else if (action === EConfirmButton.CONFIRM) {
    return false;
  } else {
    return false;
  }
}
